import { useBearerToken } from "core/hooks/useBearerToken";
import { useMenuItems } from "core/hooks/useMenuItems";
import { ApplicationErrorBoundaryPage } from "core/pages/ApplicationErrorBoundaryPage";
import type { ReactNode } from "react";
import { ApplicationLoadingDisplay } from "../ApplicationLoadingDisplay";
import { ErrorComponent } from "../ErrorComponent";

interface GlobalLoaderProps {
  children: ReactNode;
}

export function MainLoader({ children }: GlobalLoaderProps) {
  const { isLoading, isError } = useMenuItems();

  if (isError) {
    return (
      <ApplicationErrorBoundaryPage>
        <ErrorComponent apiError={isError} />
      </ApplicationErrorBoundaryPage>
    );
  }
  if (isLoading) {
    return <ApplicationLoadingDisplay />;
  }

  return <>{children}</>;
}

function TokenLoader({ children }: { children: ReactNode }) {
  const token = useBearerToken();
  if (!token) {
    return <ApplicationLoadingDisplay />;
  }
  return <>{children}</>;
}

export function GlobalLoader({ children }: { children: ReactNode }) {
  return (
    <TokenLoader>
      <MainLoader>{children}</MainLoader>
    </TokenLoader>
  );
}
